export class OperationIdRequest {
    operationId: number;
    constructor(operationId: number){
        this.operationId = operationId
    }
}